import { styled } from "@mui/material/styles";

export const MediaObjectContent = styled("div")({
    gridArea: "content",
});
